export default function removeNonCharacters(value) {
  const valueFormatted = (value || '').replace(
    /[^a-zA-Z0-9\s\sáéíóúâêîôûãõàèìòùäëïöüç]/g,
    '',
  )

  return valueFormatted
}
